export default __webpack_public_path__ + "images/7a4a1338d7516322be4f2419a8ecb8b9-military.jpg";